import { MenuContact } from "../../../Controllers/Menu/MenuContact";
import { ViewItem } from "../../Components/Classes/ViewItem";
import { LButton } from "../../Components/LButton";
import { LCaptcha } from "../../Components/LCaptcha";
import { LInput } from "../../Components/LInput";
import { LSelect } from "../../Components/LSelect";


class MenuContactView extends ViewItem {

    get controller(): MenuContact{
        return this.props.controller
    }

    render(){
        const { onSubmitForm, setTypeValue, type} = this.controller
        return <div className="submit-form">
            <form className="submit-form-target" onSubmit={onSubmitForm}>
                <LSelect
                    title="Request type"
                    onChange={setTypeValue}
                    customStyle={"typeselector"}
                    value={type}
                    name="type"
                    selectOptions={[
                        {
                            label: "Complate",
                            value: "Complate"
                        },
                        {
                            label: "Mechanics",
                            value: "Mechanics"
                        },
                        {
                            label: "Body",
                            value: "Body"
                        },
                        {
                            label: "Interior",
                            value: "Interior"
                        },
                        {
                            label: "Electrics",
                            value: "Electrics"
                        },
                        {
                            label: "Detailing",
                            value: "Detailing"
                        },
                    ]}
                />
                <LInput
                    type="phone"
                    title="Enter cell phone number"
                    name="phonenumber"
                    required
                    placeholder="+420 000 000 000"
                    customStyle="input-pref"
                />
                <LInput
                    type="text"
                    title="Enter your contact name"
                    name="fullname"
                    required
                    placeholder="Full Name"
                    customStyle="input-pref"
                />
                <LInput
                    type="email"
                    title="Enter your email address"
                    name="email"
                    required
                    placeholder="email@example.com"
                    customStyle="input-pref"
                />
                {/* Honeypot: hidden from people, bots tend to fill it */}
                <input
                    type="text"
                    name="website"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    style={{position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0}}
                />
                <LCaptcha/>
                <LButton title="Submit" isSubmit customStyle="input-submit-pref" onClick={()=>{}}/>
            </form>
        </div>
    }
}

export { MenuContactView }
